import * as types from './mutation-types'
import Vue from 'vue'
import { DEFAULT_CONFIRM_OPTIONS, DEFAULT_LIMITATION } from '../../../components/list-new/lib/list-constants'
import { isObject } from '../../../utils'
import { cloneDeep, isEmpty, isUndefined } from 'lodash'
import { localStoreMutations } from '../../mixins/local-store-module'
import { paginationMutations } from '../../mixins/pagination-module'

export default {
  ...localStoreMutations,
  ...paginationMutations,
  [types.PREPARE_LIST_STORE](state, { uId, isSqlChosen }) {
    Vue.set(
      state.listProperties,
      'confirmOptions',
      Object.assign({}, DEFAULT_CONFIRM_OPTIONS, {
        modalId: `confirm-modal-${uId}-${isSqlChosen}`,
      })
    )
  },
  [types.RESET_LIMITATION](state) {
    Vue.set(state.listProperties, 'limitation', DEFAULT_LIMITATION)
  },
  [types.SET_AGGREGATE_COLUMN](state, { aggregateColumn }) {
    Vue.set(state.listProperties, 'aggregateColumn', aggregateColumn)
  },
  [types.SET_AGGREGATE_ROW](state, { aggregateRow }) {
    Vue.set(state.listProperties, 'aggregateRow', aggregateRow)
  },
  [types.SET_AGGREGATIONS](state, { aggregations }) {
    Vue.set(state.listProperties, 'aggregations', aggregations)
  },
  [types.SET_AVAILABLE_IN_DETAIL_VIEW](state, { availableInDetailView }) {
    Vue.set(state.listProperties, 'availableInDetailView', availableInDetailView)
  },
  [types.SET_AVAILABLE_IN_LIST](state, { availableInList }) {
    Vue.set(state.listProperties, 'availableInList', availableInList)
  },
  [types.SET_COLLAPSED_BUTTONS](state, { collapsedButtons }) {
    Vue.set(state.listProperties, 'collapsedButtons', collapsedButtons)
  },
  [types.SET_COLUMN](state, { index, column }) {
    Vue.set(state.listProperties.columns, index, column)
  },
  [types.SET_COLUMNS](state, { columns }) {
    Vue.set(state.listProperties, 'columns', columns)
  },
  [types.SET_CONFIRM_OPTION](state, { option, value }) {
    Vue.set(state.listProperties, option, value)
  },
  [types.SET_CURRENT_PARAMETERS](state, { currentParameters }) {
    Vue.set(state.listProperties, 'currentParameters', currentParameters)
  },
  [types.SET_DEFAULT_SHOW_IN_LIST](state, { showInList }) {
    Vue.set(state.listProperties, 'defaultShowInList', showInList)
  },
  [types.SET_EXPANDED_ROWS](state, { rows }) {
    Vue.set(state.listProperties, 'expandedRows', rows)
  },
  [types.SET_EXTENDED_OPTIONS](state, { options }) {
    Vue.set(state.props, 'extendedOptions', options)
  },
  [types.SET_FETCHING_LIST_DATA](state, { fetchingListData }) {
    Vue.set(state, 'fetchingListData', fetchingListData)
  },
  [types.SET_FILTER](state, { data, filter }) {
    if (
      (isObject(filter) && isEmpty(filter)) ||
      (!isObject(filter) && !isUndefined(filter) && isEmpty(filter.toString()))
    ) {
      if (state.listProperties.searchParams.hasOwnProperty(data)) {
        Vue.delete(state.listProperties.searchParams, data)
      }
      return
    }
    Vue.set(state.listProperties.searchParams, data, filter)
  },
  [types.SET_GROUP_ACTIONS_RUNNING](state, { groupActionsRunning }) {
    Vue.set(state.listProperties, 'groupActionsRunning', groupActionsRunning)
  },
  [types.SET_HIDDEN_SEARCH](state, filter) {
    Vue.set(state.listProperties, 'hiddenSearch', filter)
  },
  [types.SET_LIMITATION](state, { limit }) {
    Vue.set(state.listProperties, 'limitation', limit)
  },
  [types.SET_LIST_DATA](state, { listData }) {
    Vue.set(state, 'listData', listData)
  },
  [types.SET_LIST_PROPS](state, { props }) {
    Vue.set(state, 'props', props)
  },
  [types.SET_LIST_PROPERTIES](state, { value }) {
    Vue.set(state, 'listProperties', Object.assign({}, state.listProperties, value))
  },
  [types.SET_LIST_VISIBILITY_OPTIONS](state, { options }) {
    if (options) {
      const optionsState = cloneDeep(state.listProperties.listVisibilityOptions)
      Object.keys(options).forEach((key) => {
        optionsState[key] = !!options[key]
      })
      Vue.set(state.listProperties, 'listVisibilityOptions', optionsState)
    }
  },
  [types.SET_MONGO_LIST](state, { mongoList }) {
    Vue.set(state.props, 'mongoList', mongoList)
  },
  [types.SET_ORDER](state, { column, value }) {
    if (column) {
      if (value) {
        Vue.set(state.listProperties.orderState, column, value.toLowerCase())
      } else {
        Vue.delete(state.listProperties.orderState, column)
      }
    } else {
      if (!isEmpty(value)) {
        for (const column of Object.keys(value)) {
          Vue.set(state.listProperties.orderState, column, value[column].toLowerCase())
        }
      } else {
        Vue.set(state.listProperties, 'orderState', {})
      }
    }
  },
  [types.SET_SEARCH_BAR_COLLAPSED](state, { value }) {
    Vue.set(state.listProperties, 'searchBarIsCollapsed', value)
  },
  [types.SET_PRIMARY_KEY](state, { primaryKey }) {
    Vue.set(state.listProperties, 'primaryKey', primaryKey)
  },
  [types.SET_PROCESS_ACTIONS_BUTTONS](state, { processActionsButtons }) {
    Vue.set(state.listProperties, 'processActionsButtons', processActionsButtons)
  },
  [types.SET_RECORDS_FILTERED](state, { recordsFiltered }) {
    Vue.set(state, 'recordsFiltered', recordsFiltered)
  },
  [types.SET_RECORDS_TOTAL](state, { recordsTotal }) {
    Vue.set(state, 'recordsTotal', recordsTotal)
  },
  [types.SET_ROW_CLASSES](state, { rowClasses }) {
    Vue.set(state.listProperties, 'rowClasses', rowClasses)
  },
  [types.SET_ROW_DETAILS](state, { index, value }) {
    if (index) {
      Vue.set(state.listProperties.rowDetails, index, value)
    } else {
      Vue.set(state.listProperties, 'rowDetails', value)
    }
  },
  [types.SET_ROW_STYLES](state, { rowStyles }) {
    Vue.set(state.listProperties, 'rowStyles', rowStyles)
  },
  [types.SET_COLUMN_CLASSES](state, { columnClasses }) {
    Vue.set(state.listProperties, 'columnClasses', columnClasses)
  },
  [types.SET_COLUMN_STYLES](state, { columnStyles }) {
    Vue.set(state.listProperties, 'columnStyles', columnStyles)
  },
  [types.SET_CELL_CLASSES](state, { cellClasses }) {
    Vue.set(state.listProperties, 'cellClasses', cellClasses)
  },
  [types.SET_CELL_STYLES](state, { cellStyles }) {
    Vue.set(state.listProperties, 'cellStyles', cellStyles)
  },
  [types.SET_SEARCH_PARAM](state, { name, value }) {
    Vue.set(state.listProperties.searchParams, name, value)
  },
  [types.SET_SEARCH_PARAMS](state, { params }) {
    Vue.set(state.listProperties, 'searchParams', params)
  },
  [types.SET_SEARCH_PARAMS_COMP](state, { params }) {
    Vue.set(state.listProperties, 'searchParamsComp', params)
  },
  [types.SET_SELECTED_GROUP_ACTION](state, { processId }) {
    Vue.set(state.listProperties, 'selectedGroupAction', processId)
  },
  [types.SET_SELECTED_QUEUE_ACTION](state, { processId }) {
    Vue.set(state.listProperties, 'selectedQueueAction', processId)
  },
  [types.SET_SELECTED_ROW](state, { value }) {
    Vue.set(state.listProperties, 'selectedRow', value)
  },
  [types.SET_SELECTED_ROWS](state, { value }) {
    Vue.set(state.listProperties, 'selectedRows', value)
  },
  [types.SET_SELECTED_ROWS_FILTER](state, { selectedRowsFilter }) {
    Vue.set(state.listProperties, 'selectedRowsFilter', selectedRowsFilter)
  },
  [types.SET_SHOW_IN_LIST](state, { showInList }) {
    Vue.set(state.listProperties, 'showInList', showInList)
  },
  [types.SET_SQL_CHOSEN_BUTTON_PROPS](state, { props }) {
    Vue.set(state.listProperties, 'sqlChosenButtonProps', props)
  },
  [types.SET_STORAGE_KEY](state, { value }) {
    Vue.set(state.listProperties, 'storageKey', value)
  },
  [types.SET_UNIVERSAL_FILTER](state, { value }) {
    Vue.set(state.listProperties.universalFilter, 'value', value)
  },
  [types.SET_VIEW_MODE](state, { mode }) {
    Vue.set(state.listProperties, 'viewMode', mode)
  },
  [types.SET_VISIBILITY](state, { key, value }) {
    Vue.set(state.listProperties.listVisibilityOptions, key, value)
  },
  [types.TOGGLE_LIST](state, { visibility }) {
    const options = Object.entries(cloneDeep(state.listProperties.listVisibilityOptions)).reduce(
      (accumulator, [option, value]) => {
        switch (option) {
          case 'tableHeader':
            Object.assign(accumulator, { [option]: value })
            break
          default:
            Object.assign(accumulator, { [option]: visibility })
            break
        }
        return accumulator
      },
      {}
    )
    Vue.set(state.listProperties, 'listVisibilityOptions', options)
  },
  [types.SET_EXPRESSION_CHAIN](state, { expressionChain }) {
    Vue.set(state, 'expressionChain', expressionChain)
  },
  [types.SET_FIELD_PROPERTIES_MAP](state, { fieldPropertiesMap }) {
    Vue.set(state, 'fieldPropertiesMap', fieldPropertiesMap)
  },
  [types.SET_DEFAULT_EXPRESSIONS](state, { defaultExpressions }) {
    Vue.set(state, 'defaultExpressions', defaultExpressions)
  },
  [types.UPDATE_PROP_BY_NAME](state, { name, prop, value }) {
    Vue.set(state.fieldPropertiesMap, name, { ...state.fieldPropertiesMap[name], [prop]: value })
  },
  [types.SET_IS_SAVABLE](state, { isSavable }) {
    Vue.set(state, 'isSavable', isSavable)
  },
  [types.SET_TRIGGER_NAME](state, { fieldId, triggerName }) {
    Vue.set(state.triggerNames, fieldId, triggerName)
  },
  [types.SET_FIELD_PATH_MAP](state, { fieldPathMap }) {
    Vue.set(state, 'fieldPathMap', fieldPathMap)
  },
}
